"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PermissionTypeName = exports.PermissionType = void 0;
var PermissionType;
(function (PermissionType) {
    PermissionType["attempt_read_result"] = "attempt_read_result";
    PermissionType["attempt_read_audio"] = "attempt_read_audio";
    PermissionType["attempt_read_group_result"] = "attempt_read_group_result";
    PermissionType["attempt_read_group_audio"] = "attempt_read_group_audio";
    PermissionType["attempt_edit"] = "attempt_edit";
    PermissionType["attempt_delete"] = "attempt_delete";
    PermissionType["attempt_maintenance"] = "attempt_maintenance";
    PermissionType["exercise_edit"] = "exercise_edit";
    PermissionType["exercise_delete"] = "exercise_delete";
    PermissionType["exercise_maintenance"] = "exercise_maintenance";
    PermissionType["publisher_edit"] = "publisher_edit";
    PermissionType["publisher_read"] = "publisher_read";
    PermissionType["publisher_maintenance"] = "publisher_maintenance";
    PermissionType["publisher_configuration_read"] = "publisher_configuration_read";
    PermissionType["publisher_configuration_edit"] = "publisher_configuration_edit";
    PermissionType["pronunciation_edit"] = "pronunciation_edit";
})(PermissionType = exports.PermissionType || (exports.PermissionType = {}));
exports.PermissionTypeName = 'PermissionType';
//# sourceMappingURL=permission-type.js.map